import styled from 'styled-components';

export const StyledSection = styled.section`
  position: relative;
  margin-bottom: 80px;

  @media screen and (min-width: 1024px) {
    height: 100vh;
    margin-bottom: 0;

    &:first-of-type {
      height: calc(100vh - var(--header-height));
    }
  }
`;